// import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
// import MenuIcon from "@material-ui/icons/Menu";
import IconButton from "@material-ui/core/IconButton";
import { LogoSolar } from "src/framework/components/commons";
import { NavLink, useHistory } from "react-router-dom";

import "./style.css";
import { ExitToApp } from "@material-ui/icons";
import { confirmationDialog, doLogOut, isLoggedIn$, /* openMenu$, */ pageTitle$ } from "src/framework/store";
import { Ribbon } from "../../commons/Ribbon";
import { useObservable } from "src/framework/store/storeUtil";
import { LocalStorage, SessionStorage } from "src/framework/commons";
import { FaUser } from "react-icons/fa";
import { LogoRenovigi } from "../../commons/LogoRenovigi";

const ApplicationBar = ({ classes }: { classes: any }) => {

  const ambiente = `${process.env.REACT_APP_ENV_LABEL}`
  const isProd = String(process.env.REACT_APP_IS_PROD).toUpperCase() === "TRUE";
  const pageTitle = useObservable(pageTitle$);
  const history = useHistory();
  const userInfo = LocalStorage.get("solar.userInfo", true)

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        {!isProd ? <Ribbon label={ambiente} side="left" /> : ""}
        {/* <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={() => openMenu$.next(!openMenu$.getValue())}
          edge="start"
          className={clsx(classes.menuButton)}
        >
          <MenuIcon />
        </IconButton> */}
        <NavLink className={classes.navLink} to={"/"}>
          <LogoSolar
            width={"200"}
            fillIntelbras={"#FFFFFF"}
          />
          {/* <LogoRenovigi
            width={"177"}
            height={"57"}
            fillColor={"#FFFFFF"}
          /> */}
        </NavLink>
        <Typography variant="h6" className="title" style={{ fontWeight: "bold", textAlign: "left", paddingLeft: "48px" }}>{pageTitle}</Typography>
        <span><FaUser />{userInfo?.user}</span>
        <IconButton
          color="inherit"
          aria-label="add an alarm"
          onClick={() => {
            confirmationDialog.setup({
              content: "Deseja sair da aplicação?",
              title: "Logout",
              onConfirmation: async () => {
                const redirectURL = await doLogOut();
                if (redirectURL) {
                  window.location.href = redirectURL
                  // history.push(redirectURL)
                  LocalStorage.removeAll();
                  SessionStorage.removeAll();
                  isLoggedIn$.next(false);
                }
                confirmationDialog.close();
              },
              onClose: () => confirmationDialog.close(),
            });
            confirmationDialog.open()
          }}
        >
          <ExitToApp />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export { ApplicationBar };
